<template>
  <div class="search">
    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar" @keyup.down="hoverDown" @keyup.up="hoverUp">
      <label for="search-bar-input-insa" class="blind">검색창</label>
      <input
        id="search-bar-input-insa"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="직원 검색"
        v-on:input="typing"
        @focus="typing"
        v-model="searchString"
        v-on:keyup.enter="search"
      />

      <button class="search-button" type="button" @click="search('')" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <div class="search-dropdown insa-dropdown" v-show="isSearchDropDownVisible">
      <ul class="search-dropdown__menu">
        <li v-show="searchString" v-for="memberInfo in autoCompleteList" :key="memberInfo.search_id">
          <a class="search-dropdown__menu--row" @click="clickAutoComplete(memberInfo.name)">{{ memberInfo.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardSearchBox',
  data() {
    return {
      searchString: '',
      isSearchComplete: false,
      autoCompleteList: [],
    };
  },
  props: {
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    typing(event) {
      if (event.target.value.length <= 0) {
        return false;
      }
      this.searchString = event.target.value;
      let searchString = this.searchString;
      if (searchString.length > 0) {
        this.autoCompleteList = window.OrgMember._search_data.filter((memberInfo) => {
          return memberInfo.name.includes(searchString);
        });
      } else {
        this.autoCompleteList = [];
      }
      this.setIsSearchDropDownVisible(this.autoCompleteList.length > 0);
    },
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    clickAutoComplete(name) {
      this.searchString = name;
      this.search();
    },
    search() {
      window.OrgMember.searchResult(this.searchString, 'name');
      this.isSearchComplete = true;
      this.setIsSearchDropDownVisible(false);
    },
    openDetailSearch() {
      this.setIsSearchDropDownVisible(false);
    },
    cancelSearch() {
      window.OrgMember.cancelMemberSearch();
      this.isSearchComplete = false;
      this.setIsSearchDropDownVisible(false);
    },
  },
};
</script>

<style scoped lang="scss">
.insa-dropdown {
  height: 200px;
  overflow-y: auto;
}
</style>
